import { authorizedInstance } from "../config/axios"

export const getAuditLogs = async ({ page, limit, filters }) => {
  const query = new URLSearchParams({
    page,
    limit,
    ...filters,
  })

  const response = await authorizedInstance.get(`/audit-logs?${query}`)

  return response.data
}

export const getAuditLogWithLogId = async (logId) => {
  const response = await authorizedInstance.get(
    `/audit-logs/logs?logId=${logId}`
  )

  return response.data
}

export const getAuditLogsWithAccessionNumber = async (accessionNumber) => {
  const response = await authorizedInstance.get(
    `/audit-logs/log?accessionNumber=${accessionNumber}`
  )

  return response.data
}
